
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1s55x_n5kgx_9",
  "label": "awsui_label_1s55x_n5kgx_13",
  "label-top": "awsui_label-top_1s55x_n5kgx_27",
  "stud": "awsui_stud_1s55x_n5kgx_32"
};
  